export default __webpack_public_path__ + "f7674bad4d559529a9c2117d56464270.svg";